import * as fabric from 'office-ui-fabric-react';
import { Label, Toggle } from 'office-ui-fabric-react';
import { FC, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import * as api from '../../../../api/generated';
import { KendoLoading } from '../../../../components';
import { useConfirmation } from '../../../../components/dialogs';

interface IProps {
    organizationId: number;
}

const Evacuation: FC<IProps> = ({ organizationId }) => {
    const { confirmAsync } = useConfirmation();

    const [evacuationStatus, setEvacuationStatus] = useState<boolean | undefined>(undefined);

    const fetchData = async () => {
        try {
            const resp = await api.administration.getEvacuationStatus(organizationId);
            setEvacuationStatus(resp?.evacuationStatus);
        } catch (ex) {
            toast.error('Nepavyko gauti evakuacijos būsenos');
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const onChange = async ({}, checked: boolean | undefined) => {
        if (checked != undefined) {
            if (checked) {
                await handleApprove(checked!);
            } else {
                setEvacuationStatus(checked);
                await api.administration.updateEvacuationStatus({ organizationInformationId: organizationId, evacuationStatus: checked });
            }
            fetchData();
        }
    };

    const handleApprove = async (checked: boolean) => {
        try {
            const { success } = await confirmAsync('Evakuacijos funkcijos įjungimas', 'Ar tikrai norite įjungti evakuacijos pranešimą ekranuose?');

            if (!success) {
                return;
            }

            setEvacuationStatus(checked);
            await api.administration.updateEvacuationStatus({ organizationInformationId: organizationId, evacuationStatus: checked });
            toast.warning('Evakuacija įjungta');
            fetchData();
        } catch (ex) {
            toast.error('Evakuacijos nepavyko įjungti');
        }
    };

    return (
        <>
            {evacuationStatus == undefined && <KendoLoading />}
            {evacuationStatus != undefined && (
                <fabric.StackItem>
                    <Label>Evakuacija</Label>
                    <Toggle checked={evacuationStatus} onChange={onChange} />
                </fabric.StackItem>
            )}
        </>
    );
};

export default Evacuation;
